import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

/** @param officeId - the location Billing Details was opened for; the selected office when omitted */
export const useRetryBilling = (officeId?: string) => {
  return useMutation({
    mutationKey: ['retryBilling'],
    mutationFn: () => PermanentJobsService.retryBilling(officeId),
  });
};
